import classNames from 'classnames';
import * as dateFnsCompat from 'utils/date-fns-compat';
import { toSafeExternalUrl } from '../../../../utils';

import he from 'he';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { contentIcons, contentStatus, dateFormats, cpdCategoryType } from '../../../../constants';
import { getIndustryLabelForCpdCategoryNoParenthesis } from '../../../../services';
import { cpdCategorysActions } from '../../../../state/modules/areas-of-advice';
import { ConfirmationModal, Icon } from '../../../components';
import Loading from '../../loading';
import { getCpdCategoryLabel } from '../../../../constants/cpd-activity'

const uuidv1 = require('uuid/v1');

const ContentTableFields = {
  contentType: {
    title: 'Type',
    field: 'contentType',
  },
  industry: {
    title: 'Industry',
    field: 'industry',
  },
  cpdCategory: {
    title: 'CPD Category',
    field: 'cpdCategory'
  },
  title: {
    title: 'Title',
    field: 'title',
    sortable: true
  },
  estimatedReadingTime: {
    title: 'Time',
    field: 'estimatedReadingTime',
    sortable: true
  },
  puplicationDate: {
    title: 'Publication Date',
    field: 'publicationDate',
    sortable: true
  },
  expiryDate: {
    title: 'Expiry date',
    field: 'expiryDate',
    sortable: true
  },
  cpdPoints: {
    title: 'Hours',
    field: 'cpdPoints',
    sortable: true
  },
  questionCount: {
    title: 'Q\'s',
    field: 'questionCount'
  },
  status: {
    title: 'Status',
    field: 'status'
  },
  goals: {
    title: 'Goals',
    field: 'goals'
  }
};

class ContentTable extends Component {

  constructor() {
    super();

    this.state = {
      sorting: {},
      content: []
    };
  }

  componentDidMount() {
    if (this.props.cpdCategorys.length === 0 && !this.props.isFetchingCpdCategorys) {
      this.props.getCpdCategorys();
    }

    this.props.getContent();
  }

  componentWillReceiveProps(nextProps) {
    const { contentPerPage, contentResult } = nextProps;
    const content = contentPerPage ?
      fp.take(contentPerPage)(contentResult.content) :
      contentResult.content;

    this.setState({
      content: content
    });
  }

  renderSortingArrow(field) {
    if (this.state.sorting[field] === 'asc') {
      return <Icon icon='arrow-up-medium' />;
    }
    else if (this.state.sorting[field] === 'desc') {
      return <Icon icon='arrow-down-medium' />;
    }
    else {
      return <span><Icon icon='arrow-down-medium' /><Icon icon='arrow-up-medium' /></span>
    }
  }

  renderTableHeadings() {
    const hideIndustries = this.props.hideIndustries
    return fp.flow(
      fp.filter(
        (heading) => {
          return !hideIndustries || heading.field !== 'industry'
        }
      ),
      fp.map(
        (heading) =>
          <td key={heading.field} className={heading.field}>
            {this.props.updateBySorting ?
              heading.sortable ?
                <Button onClick={() => this.sortBy(heading.field, this.state.sorting[heading.field])} className='heading-btn' bsStyle='plain'>
                  {heading.title} &nbsp;
                  {
                    this.renderSortingArrow(heading.field)
                  }
                </Button> :
                <span className='heading-span'>
                  {heading.title}
                </span> :
              <span>{heading.title}</span>
            }
          </td>)
    )(ContentTableFields);
  }

  sortBy(field) {
    let nextSortOrder = null;
    if (!this.state.sorting[field]) {
      nextSortOrder = 'asc';
    }

    if (this.state.sorting[field] === 'asc') {
      nextSortOrder = 'desc';
    }

    if (this.state.sorting[field] === 'desc') {
      nextSortOrder = undefined;
    }

    // This will remove all other fields' sorting.
    this.setState({
      sorting: { [field]: nextSortOrder }
    });

    this.props.updateBySorting(field, nextSortOrder);
  }

  confirmDelete(content) {
    this.props.deleteContent(content.id, this.props.currentContentQuery);
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    const updatedContent = fp.map((a) => Object.assign({}, a, { showDeleteModal: false }))(this.state.content);
    this.setState({
      content: updatedContent
    });
  }

  deleteContent(content) {
    const updatedContent = fp.map((a) => Object.assign({}, a, { showDeleteModal: content.id === a.id }))(this.state.content);
    this.setState({
      content: updatedContent
    });
  }

  showArchiveModal(content) {
    const updatedContent = fp.map((a) => Object.assign({}, a, { showArchiveModal: a.id === content.id }))(this.state.content);
    this.setState({
      content: updatedContent
    });
  }

  closeArchiveModal() {
    const updatedContent = fp.map((a) => Object.assign({}, a, { showArchiveModal: false }))(this.state.content);
    this.setState({
      content: updatedContent
    });
  }

  confirmArchive(content) {
    this.props.archiveContent(content.id);
    this.closeArchiveModal();
  }

  render() {
    const { className, industriesWithCpdCategorys, cpdCategorys } = this.props;
    const allGoals = fp.flow(
      fp.flatMap('goals'),
      fp.uniqBy('id')
    )(industriesWithCpdCategorys);

    const coreCategoryIds = cpdCategorys
      .filter(({ categoryType }) => categoryType === cpdCategoryType.core)
      .map(({ id }) => id);

    return (
      <table className={classNames('table--publishers', className)}>
        <thead>
          <tr>
            {
              this.renderTableHeadings()
            }
            <td aria-label='actions'>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          {
            this.state.content.length > 0 ?
              fp.flow(
                fp.map(
                  (content) => {
                    const cpdCategoryId = fp.get('cpdCategorys.[0].cpdCategoryId')(content)
                    return {
                      ...content,
                      industry: getIndustryLabelForCpdCategoryNoParenthesis(cpdCategoryId, industriesWithCpdCategorys),
                      cpdPoints: fp.flow(
                        // Only calculate points for core category.
                        fp.filter(({ cpdCategoryId }) => coreCategoryIds.includes(cpdCategoryId)),
                        fp.map('points'),
                        fp.sum
                      )(content.cpdCategorys),
                      cpdCategory: getCpdCategoryLabel(content.cpdCategorys, this.props.cpdCategorys)
                    }
                  }
                ),
                fp.map((content) =>
                  <tr key={`${content.id} - ${uuidv1()}`}>
                    <td className='content-type'><Icon icon={fp.get(content.contentType)(contentIcons)} /></td>
                    {
                      this.props.hideIndustries ?
                        null :
                        <td className='industry'>{content.industry ? content.industry : 'Unknown'}</td>
                    }
                    <td className='area-advice'>{content.cpdCategory}</td>
                    <td className='title'>
                      {
                        content.link ?
                          <Link to={toSafeExternalUrl(he.decode(content.link)) || '#'} target='_blank'>{he.decode(content.title)}</Link> :
                          content.title
                      }
                    </td>
                    <td className='time-to-complete'>{content.estimatedReadingTime}</td>
                    <td className='publication-date'>{dateFnsCompat.format(dateFnsCompat.parse(content.publicationDate), dateFormats.ShortDate)}</td>
                    <td className='caddie-link-expiry'>{dateFnsCompat.format(dateFnsCompat.parse(content.expiryDate), dateFormats.ShortDate)}</td>
                    <td className='cpd-points'>{content.cpdPoints}</td>
                    <td className='num-questions'>{content.questionCount}</td>
                    <td className='status'>{content.status}</td>
                    <td className='goals'>{
                      fp.flow(
                        fp.filter(
                          (goal) => fp.contains(goal.id)(content.goals)
                        ),
                        fp.map(
                          ({ id, name }) => <div key={id} className='nowrap'>{name}</div>
                        ),
                        (goals) => fp.isEmpty(goals) ? <div className='nowrap'>n/a</div> : goals
                      )(allGoals)
                    }</td>
                    <td className='edit-row'>
                      <LinkContainer to={{ pathname: this.props.contentDetailsRoute, search: `?${queryString.stringify({ contentId: content.id })}` }}>
                        <Button bsStyle='plain'><Icon icon='edit-medium' /> Edit</Button>
                      </LinkContainer>
                      {
                        this.props.archiveContent && content.status !== contentStatus.Archived.value ?
                          [
                            <ConfirmationModal
                              key={`archive-${content.id}-modal`}
                              show={content.showArchiveModal}
                              actions={[
                                {
                                  onConfirmAction: () => this.confirmArchive(content),
                                  actionLabel: 'Archive',
                                }
                              ]}
                              cancel={() => this.closeArchiveModal()}
                              message={
                                <p>
                                  Are you sure you want to archive this content? Once archived, users will not be able to complete it in Caddie.
                                </p>
                              }
                              headingText={<span>Archive Content</span>}
                            />,
                            <Button key={`archive-${content.id}-button`} bsStyle='plain' className='warning' onClick={() => {
                              this.showArchiveModal(content)
                            }}>Archive</Button>
                          ] : null
                      }
                      {
                        this.props.allowDelete ?
                          [
                            <ConfirmationModal
                              key={`delete-${content.id}`}
                              show={content.showDeleteModal}
                              actions={[
                                {
                                  onConfirmAction: () => this.confirmDelete(content),
                                  actionLabel: 'Delete',
                                }
                              ]}
                              cancel={() => this.closeDeleteModal()}
                              message={
                                <span>
                                  You are about to delete <b>{content.title}</b>.
                                  &nbsp;
                                  Any CPD earned by users for this content will also be deleted.
                                </span>
                              }
                              headingText={<span>Delete Content</span>}
                            />,
                            <Button key={`edit-${content.id}`} bsStyle='plain' className='warning' onClick={() => this.deleteContent(content)}><Icon icon='delete-medium' /> Delete</Button>
                          ] : null
                      }
                    </td>
                  </tr>
                )
              )(this.state.content) :
              this.props.isFetching ?
                null :
                <tr>
                  <td colSpan={7}>
                    No content found, click ADD CONTENT to add content.
                  </td>
                </tr>
          }
          {
            this.props.isFetching ?
              <tr>
                <td colSpan={7}>
                  <Loading />
                </td>
              </tr> :
              null
          }
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
  isFetchingCpdCategorys: state.cpdCategorys.isFetching
});

const mapDispatchToProps = (dispatch) => ({
  getCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
});

ContentTable.propTypes = {
  currentContentQuery: PropTypes.object,
  contentPerPage: PropTypes.number,
  updateBySorting: PropTypes.func,
  allowDelete: PropTypes.bool
};

ContentTable.defaultProps = {
  allowDelete: false
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentTable);


// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-content/content-table.js